export default "__VITE_ASSET__BMQODKvy__"